const initialState = {
    predefinedListCollapsed: JSON.parse(localStorage.getItem("predefinedListCollapsed")) || false,
    customListCollapsed: JSON.parse(localStorage.getItem("customListCollapsed")) || false,
};

export const setPredefinedListCollapsed = value => dispatch => {
    localStorage.setItem("predefinedListCollapsed", JSON.stringify(value));
    dispatch({ type: "SET_PREDEFINED_COLLAPSED", payload: value });
};

export const setCustomListCollapsed = value => dispatch => {
    localStorage.setItem("customListCollapsed", JSON.stringify(value));
    dispatch({ type: "SET_CUSTOM_COLLAPSED", payload: value });
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "SET_PREDEFINED_COLLAPSED":
            return { ...state, predefinedListCollapsed: action.payload };
        case "SET_CUSTOM_COLLAPSED":
            return { ...state, customListCollapsed: action.payload };
        default:
            return state;
    }
}
